import type { RefStore } from "./store";

export type RoleId = -1 | -2 | -3 | -4 | -5 | -6 | -7;

export const ADMIN_ROLE_ID: RoleId = -3;
export const SUPPORT_ROLE_ID: RoleId = -7;

export const RoleIdLabels: Record<RoleId, string> = {
  [-1]: "Veterinário",
  [-2]: "Assistente Veterinário",
  [-3]: "Admin",
  [-4]: "Grooming",
  [-5]: "Gestor Loja",
  [-6]: "Colaborador Loja",
  [-7]: "Suporte",
};

export type EmployeeRefOption = {
  id: number;
  value: string;
};

export type EmployeeRole = Omit<EmployeeRefOption, "id"> & {
  id: RoleId;
};

export type EmployeeStore = Pick<
  RefStore,
  "id" | "name" | "externalCode" | "storeCode"
>;

/**
 * One service an employee performs, and the species they perform it for.
 *
 * Grouped by service: a service the employee does not perform has no entry.
 */
export type EmployeeServiceEntry = {
  service: { id: number; code: string; name: string };
  species: EmployeeRefOption[];
};

export type Employee = {
  id: number;
  name: string;
  username: string;
  email?: string | null;
  externalCode: string;
  serviceType: EmployeeRefOption;
  role: EmployeeRole;
  /** Additional Hubs roles, when the employee endpoint includes mixed roles. */
  roles?: EmployeeRole[];
  isActive: boolean;
  stores: EmployeeStore[];
  /**
   * The services this employee is assigned, per species. Absent from the
   * endpoints that do not embed assignments.
   */
  services?: EmployeeServiceEntry[];
};

export type AuthData = Employee;
